"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = __importDefault(require("./base"));
let cancelExpertToken;
let cancelServiceExpertToken;
class Experts extends base_1.default {
    expert(uid) {
        return this.get(`/experts/${uid}`, {});
    }
    categories() {
        return this.get('/experts/categories', {});
    }
    experts(data) {
        this.cancelAllRequest();
        cancelExpertToken = this.Axios.CancelToken.source();
        return this.post('/experts/filter', data, {}, cancelExpertToken.token);
    }
    serviceExperts(data) {
        this.cancelAllRequest();
        cancelServiceExpertToken = this.Axios.CancelToken.source();
        return this.post('/experts/filter/services', data, {}, cancelServiceExpertToken.token);
    }
    services() {
        return this.get('/experts/services', {});
    }
    cancelAllRequest() {
        if (typeof cancelExpertToken != typeof undefined) {
            cancelExpertToken.cancel("Operation canceled due to new request.");
        }
        if (typeof cancelServiceExpertToken != typeof undefined) {
            cancelServiceExpertToken.cancel("Operation canceled due to new request.");
        }
    }
}
exports.default = new Experts();
